import styled from '@emotion/styled';
import { Grid } from '@material-ui/core';
import { createElement, FC } from 'react';

import { SPACING_LARGE } from '../../../constant/spacing';
import FormatSelectBlock from './FormatSelectBlock';
import { AddOriginalFormatsButton, AddResizeFormatsButton } from './index';

interface Props {
  setIsOriginalFormatsDialogOpen: (state: boolean) => void;
  setIsResizeFormatsDialogOpen: (state: boolean) => void;
}

const CreationSetsFieldDefaultView: FC<Props> = ({ setIsOriginalFormatsDialogOpen, setIsResizeFormatsDialogOpen }) => (
  <CreationSetsField>
    <Grid container direction="row" justifyContent="flex-start" alignItems="stretch" spacing={2}>
      <FormatSelectBlock titleMessageId={'project_editing_page.basic_setting.creative_formats.original'} gridItemLg={5}>
        <AddOriginalFormatsButton
          onClick={() => {
            setIsOriginalFormatsDialogOpen(true);
          }}
        />
      </FormatSelectBlock>
      <FormatSelectBlock titleMessageId={'project_editing_page.basic_setting.creative_formats.resize'}>
        <AddResizeFormatsButton
          disabled
          onClick={() => {
            setIsResizeFormatsDialogOpen(true);
          }}
        />
      </FormatSelectBlock>
    </Grid>
  </CreationSetsField>
);

const CreationSetsField = styled('div')({
  marginBottom: SPACING_LARGE,
});

export default CreationSetsFieldDefaultView;
